import { AppButton } from '@clickguard/design-system'
import { ShopifyConnectOnboarding } from 'components/shopify-install'
import { useFeatureFlag } from 'services/feature-flags'
import { TrackingMethod } from '../../types'
import { MethodSelector } from './method-selector'
import { ManualInstall } from './manual-install'
import { EmailDeveloper } from './email-developer'
import { InviteTeamMemberTracking } from '../invite-team-member-tracking'

interface TrackingCodeTabProps {
	accountId: string
	assetId: string
	selectedMethod: TrackingMethod | null
	onMethodChange: (method: TrackingMethod) => void
	onVerify?: () => void
	onDirectComplete?: () => Promise<void>
	onGtmInstall?: () => void
}

export const TrackingCodeTab = ({
	accountId,
	assetId,
	selectedMethod,
	onMethodChange,
	onVerify,
	onGtmInstall,
	onDirectComplete
}: TrackingCodeTabProps) => {
	const shopifyEnabled = useFeatureFlag('shopify_enabled')
	return (
		<div className="flex flex-col">
			<p className="text-[16px] leading-[22px] text-t-checkbox-unactive">
				This allows ClickGuard&apos;s AI to analyze visitor behavior on your
				website (such as clicks, cursor movement, typing, and form interactions)
				and estimate bot probability.{' '}
				<a
					href="https://help.clickguard.com/hc/en-us/articles/11762667031325-What-is-ClickGuard-Tracking-Code"
					target="_blank"
					rel="noopener noreferrer"
					className="text-brand underline"
				>
					Learn more
				</a>
			</p>

			<div className="mt-6">
				<MethodSelector
					selectedMethod={selectedMethod}
					onMethodChange={onMethodChange}
				/>
			</div>

			{selectedMethod === 'gtm' && (
				<div className="flex flex-col gap-6 mt-6">
					<AppButton
						variant="marketing"
						size="lg"
						fullWidth
						label="Continue"
						onClick={onGtmInstall}
					/>
					<InviteTeamMemberTracking />
				</div>
			)}
			{selectedMethod === 'manual' && (
				<div className="flex flex-col gap-6 mt-6">
					<ManualInstall />
					<AppButton
						variant="marketing"
						size="lg"
						fullWidth
						label="Verify installation"
						onClick={onVerify}
					/>
					<InviteTeamMemberTracking />
				</div>
			)}
			{shopifyEnabled && selectedMethod === 'shopify' && (
				<div className="flex flex-col gap-6 mt-6">
					<ShopifyConnectOnboarding accountId={accountId} assetId={assetId} onComplete={onDirectComplete} />
				</div>
			)}
			{selectedMethod === 'email' && (
				<div className="flex flex-col gap-6 mt-6">
					<EmailDeveloper onDirectComplete={onDirectComplete} />
				</div>
			)}
		</div>
	)
}
